import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "../../styles/index.less";
import { useAuth } from "../../context/authContext";
import { useFlyout } from "../../context/layoutContext";
import service from "../../services/service";
import { toast } from "react-toastify";

const Navbar: React.FC = () => {
  const logo1 = new URL("../../assets/logo1.png", import.meta.url).href;
  const logo2 = new URL("../../assets/logo2.jpg", import.meta.url).href;

  const profileImg = new URL("../../assets/profile.png", import.meta.url).href;

  const { token, user, logout } = useAuth();
  const { openLogin } = useFlyout();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await service.logout();
      toast.success("You have been logged out successfully!", {
        position: "top-right",
        autoClose: 2500,
      });
    } catch (error) {
      console.error("Logout service error:", error);
      toast.error("Logout failed. Please try again.", {
        position: "top-right",
        autoClose: 2500,
      });
    }
    logout();
    setMenuOpen(false);
  };

  return (
    <header className="navbar">
      <div className="navbar__top-line"></div>

      <div className="navbar__content">
        {/* Combined left section */}
        <div className="navbar__group">
          <div className="navbar__logos">
            <NavLink
              to="/"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              <img src={logo1} alt="CareEdge Logo" className="navbar__logo1" />
            </NavLink>

            <div className="navbar__logos-divider"></div>
            <NavLink
              to="/"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              <img
                src={logo2}
                alt="RelitsInfraEdge Logo"
                className="navbar__logo2"
              />
            </NavLink>
          </div>

          {/* Hamburger (only visible in mobile) */}
          <div
            className={`navbar__hamburger ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>

          {/* Navigation links */}
          <nav className={`navbar__links ${menuOpen ? "active" : ""}`}>
            <NavLink
              to="/reits"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={() => {
                setMenuOpen(false);
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              REITs
            </NavLink>

            <NavLink
              to="/invits"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={() => {
                setMenuOpen(false);
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              InvITs
            </NavLink>

            {/* Mobile login/logout inside menu */}
            <div className="navbar__mobile-auth">
              {token ? (
                <>
                  <div className="navbar__welcome">
                    <img
                      src={profileImg}
                      alt="Profile"
                      className="navbar__profile-img"
                    />
                    <span>{user?.name || user?.email || "User"}</span>
                  </div>
                  <button className="navbar__login" onClick={handleLogout}>
                    Logout
                  </button>
                </>
              ) : (
                <button
                  className="navbar__login"
                  onClick={() => {
                    setMenuOpen(false);
                    openLogin();
                  }}
                >
                  Login
                </button>
              )}
            </div>
          </nav>
        </div>

        {/* Right side (desktop login/logout) */}
        <div className="navbar__right">
          {token ? (
            <div className="navbar__user-info">
              <div className="navbar__welcome">
                <img
                  src={profileImg}
                  alt="Profile"
                  className="navbar__profile-img"
                />
                <span>{user?.name || user?.email || "User"}</span>
              </div>

              <button className="navbar__login" onClick={handleLogout}>
                Logout
              </button>
            </div>
          ) : (
            <button className="navbar__login" onClick={openLogin}>
              Login
            </button>
          )}
        </div>
      </div>
      {menuOpen && (
        <div
          className="navbar__overlay active"
          onClick={() => setMenuOpen(false)}
        ></div>
      )}
    </header>
  );
};

export default Navbar;
